import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/react';
import rafSchedule from 'raf-schd';
import { WidthObserver } from '@atlaskit/width-detector';
var SCROLLBAR_WIDTH = 30;
export function getBreakpoint() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var MAX_S = 1266;
  var MAX_M = 2146;
  if (width >= MAX_S && width < MAX_M) {
    return 'M';
  } else if (width >= MAX_M) {
    return 'L';
  }
  return 'S';
}
export function createWidthContext() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return {
    width: width,
    breakpoint: getBreakpoint(width)
  };
}
export var WidthContext = /*#__PURE__*/React.createContext(createWidthContext());
var Provider = WidthContext.Provider,
  Consumer = WidthContext.Consumer;
export var WidthProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(WidthProvider, _React$Component);
  var _super = _createSuper(WidthProvider);
  function WidthProvider(props) {
    var _this;
    _classCallCheck(this, WidthProvider);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 0
    });
    _defineProperty(_assertThisInitialized(_this), "setWidth", rafSchedule(function (width) {
      // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
      if (Math.abs(_this.state.width - width) < SCROLLBAR_WIDTH) {
        return;
      }
      _this.setState({
        width: width
      });
    }));
    _this.state.width = document.body.offsetWidth;
    return _this;
  }
  _createClass(WidthProvider, [{
    key: "render",
    value: function render() {
      return jsx("div", {
        css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          position: relative;\n          width: 100%;\n        "]))),
        className: this.props.className
      }, jsx(WidthObserver, {
        setWidth: this.setWidth,
        offscreen: true
      }), jsx(Provider, {
        value: createWidthContext(this.state.width)
      }, this.props.children));
    }
  }]);
  return WidthProvider;
}(React.Component);
export { Consumer as WidthConsumer };